// extracted by mini-css-extract-plugin
module.exports = {"Ethics":"Ethics_Ethics__1Esbt"};